import { AuthenticatedRestClient } from '@adaptiva/data-service';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class LlmClient extends AuthenticatedRestClient {

	public getBaseUrl(): string {
		return `${super.getBaseUrl()}/llm`;
	}

}
